import { cast } from 'mobx-state-tree';
import { TimelineGroupType } from '@modules/timetable';
import { batches_for_timetable_selectQuery } from '@app-types/graphql-types';
import { TimetableModelType } from '../../Timetable';

export const setTimelineGroupsAccordingToBatch = ({
  batch,
  self,
}: {
  batch: batches_for_timetable_selectQuery['active_batch'][0] | null;
  self: Partial<TimetableModelType>;
}): void => {
  if (batch) {
    const classesForTimetable: TimelineGroupType[] = [];

    batch.batch_classes.forEach((classData) => {
      classesForTimetable.push({ id: `lecture/${classData.id}`, title: `${classData.name}`, type: 'subject' });
    });

    self.timelineGroups = cast(classesForTimetable);
  }
};
